import React from 'react';
import styled from 'styled-components';
import { Popover as Component } from 'antd';

const Popover = styled(props => <Component {...props} />)``;

/** @component */
export default Popover;
